import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { BaseGraphqlService } from "../graphQL.service";
import { Observable, of } from "rxjs";
import { GET_STORE_CONFIGURATION, GET_STORE_INFO } from "../../querys/store-configurations/store-configurations.graphql";
import { GET_STORE_FUNCTIONALITY } from "../../querys/content/content.graphql";


@Injectable({ providedIn: 'root' })
export class StoreConfigurationService {

  private graphqlUrl!: string;
  private graphqlUrlAccount!:string;
  private graphlUrlContent!:string;

  constructor(private _graphqlService: BaseGraphqlService) {
    this.graphqlUrl = environment.urlsGraphQL.back_office;
    this.graphlUrlContent = environment.urlsGraphQL.content;
  }


  /**
   *Metodo que obtiene la configuracion de la tienda
   *
   * @return {*}  {Observable<StoreConfigurationsResponse>}
   * @memberof StoreConfigurationService
   */
  public getStoreConfigurations(): Observable<any> {

    const filter = {
      storeId:environment.storeIdComplete,
    };
    return this._graphqlService.queryFilter<any,any>(
      GET_STORE_CONFIGURATION,
      this.graphqlUrl,
      filter
    );
  }

  /**
   *Metodo que obtiene la informacion de la tienda
   *S
   */
  public getStoreInfo(storeId:string):Observable<any>{
    var variable = {storeID:storeId}

    return this._graphqlService.queryFilter<any,any>(
      GET_STORE_INFO,
      this.graphqlUrlAccount,
      variable
    );
  }

   public  getStoreFunctionality(storeId:string): Observable<any> { 
    var variable = {storeId:storeId}
    return this._graphqlService.queryFilter<any, any>(
      GET_STORE_FUNCTIONALITY,
      this.graphlUrlContent,
      variable
    );
  }


}

